import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

interface ConsentSmsIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
  circleColor?: keyof AppColors;
}

export const ConsentSmsIcon: React.FC<ConsentSmsIconProps> = ({
  size = 80,
  color = 'iconPrimary',
  circleColor = 'borderSubtle',
}) => {
  const { theme: colors } = useUnistyles();
  return (
    <Svg width={size} height={size} viewBox="0 0 80 80" fill="none">
      <Circle
        cx={40}
        cy={40}
        r={39}
        stroke={colors[circleColor]}
        strokeWidth={2}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.09 48.792C36.942 50.442 34.02 52 32.593 52c-1.09 0-1.429-.997-.868-1.787.476-.676 1.365-2.028 1.841-3.036C30.222 45.505 28 42.171 28 38.413 28 32.651 33.333 28 40 28s12 4.651 12 10.413c0 6.003-5.534 10.597-12.91 10.38Zm-5.45 1.203c-.053.069-.021.138.064.103.963-.423 2.846-1.672 4.148-2.692.402-.343.74-.504 1.185-.492l.302.008c.28.008.503.015.661.015 5.714 0 10.254-3.827 10.254-8.524 0-4.685-4.54-8.511-10.254-8.511-5.704 0-10.243 3.826-10.243 8.511 0 3.06 1.904 5.728 5.227 7.4.677.344.751.871.455 1.456-.36.744-1.206 1.936-1.799 2.726ZM36 40a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
